import { ReactNode } from "react";
import { Bars3Icon } from "@heroicons/react/24/outline";
import { useHeaderContext } from "./HeaderContext";
import { UnstyledButton } from "cy-fe";

export function LayoutFrame({
  openSidebar,
  headerMenuItems,
  children,
}: {
  openSidebar: () => void;
  children: ReactNode;
  headerMenuItems: ReactNode;
}) {
  const { headerRender } = useHeaderContext();
  return (
    <div className="pt-8 lg:pr-10 lg:pl-72">
      <div className="z-40 flex h-16 shrink-0 items-center gap-x-4 bg-white px-4 sm:gap-x-6 sm:px-6 lg:px-8">
        <UnstyledButton
          className="-m-2.5 p-2.5 text-gray-700 lg:hidden"
          onClick={() => {
            openSidebar();
          }}
          type="button"
        >
          <span className="sr-only">Open sidebar</span>
          <Bars3Icon aria-hidden="true" className="h-6 w-6" />
        </UnstyledButton>
        {!!headerRender && headerRender}
        <div className="flex flex-1 gap-x-4 self-stretch lg:gap-x-6">
          <div className="relative flex flex-1">&nbsp;</div>
          <div className="flex items-center gap-x-4 lg:gap-x-6">
            {headerMenuItems}
          </div>
        </div>
      </div>

      <main className="pt-3 pb-9 sm:pt-9">
        <div className="px-4 sm:px-6 lg:px-8">{children}</div>
      </main>
    </div>
  );
}
